export const getPurchaseUserId = (state) => state.payment.purchaseUserId;
